import { render, staticRenderFns } from "./TheTable.vue?vue&type=template&id=ce4a33dc&scoped=true"
import script from "./TheTable.vue?vue&type=script&lang=js"
export * from "./TheTable.vue?vue&type=script&lang=js"
import style0 from "./TheTable.vue?vue&type=style&index=0&id=ce4a33dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4a33dc",
  null
  
)

export default component.exports